import { Transaction } from "../../../domain/types/Transaction";

export const calculateTrends = (
  currentData: number,
  previousData: number,
): { percentage: number; direction: "up" | "down" | "stable" } => {
  const difference = currentData - previousData;
  const percentage = (difference / previousData) * 100;

  return {
    percentage: Math.abs(Number(percentage.toFixed(1))),
    direction: percentage > 0 ? "up" : percentage < 0 ? "down" : "stable",
  };
};

export const groupTransactionsByCategory = (transactions: Transaction[]) => {
  return transactions.reduce(
    (acc, transaction) => {
      const category = transaction.category_description;
      if (!acc[category]) {
        acc[category] = 0;
      }
      acc[category] += Math.abs(transaction.amount);
      return acc;
    },
    {} as Record<string, number>,
  );
};

export const generateChartColors = (count: number) => {
  const baseColors = [
    { r: 99, g: 102, b: 241 },
    { r: 34, g: 197, b: 94 },
    { r: 234, g: 179, b: 8 },
    { r: 239, g: 68, b: 68 },
    { r: 168, g: 85, b: 247 },
  ];

  return Array.from({ length: count }, (_, i) => {
    const color = baseColors[i % baseColors.length];
    return `rgba(${color.r}, ${color.g}, ${color.b}, 0.8)`;
  });
};

export const formatChartData = (data: Record<string, number>) => {
  const labels = Object.keys(data);
  const values = Object.values(data);
  const colors = generateChartColors(labels.length);

  return {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 0,
      },
    ],
  };
};
